<template>
  <Layout class="app" :isMargin="false">
    <NavBar slot="nav" :headerMenu="false" />
    <div class="content">
      <div class="login">
        <div class="left">
          <img src="../../../assets/img/loginBg.png" alt="" />
        </div>
        <div class="right">
          <div class="tabs">
            <div
              class="tab_pane"
              v-for="item in tabsList"
              :key="item.id"
              :class="activeName === item.id ? 'active' : ''"
              @click="tabsChange(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 验证码登录 -->
          <div class="code form" v-if="activeName === 1">
            <div class="ins">
              <el-input
                placeholder="请输入手机号"
                v-model="mobileForm.phone"
                maxlength="11"
                autocomplete="off"
              ></el-input>
              <span @click="getVerifyCode" :class="time === 60 ? '' : 'active'">
                {{ time === 60 ? "获取验证码" : time + "s" }}</span
              >
            </div>
            <div class="ins">
              <el-input
                placeholder="请输入验证码"
                v-model="mobileForm.code"
                maxlength="4"
                autocomplete="off"
              ></el-input>
            </div>
          </div>
          <!-- 密码登录 -->
          <div class="password form" v-else>
            <div class="ins">
              <el-input
                placeholder="请输入手机号"
                v-model="mobileForm.phone"
                maxlength="11"
                autocomplete="off"
              ></el-input>
            </div>
            <div class="ins">
              <el-input
                :type="type"
                placeholder="请输入密码"
                v-model="mobileForm.password"
                autocomplete="off"
                @focus="type = 'password'"
              ></el-input>
            </div>
            <span class="forget" @click="forgetPassword">忘记密码？</span>
          </div>
          <div class="btn" @click="login">登录</div>
          <div class="tip">
            登录默认同意并接受
            <a href="./userAgreement.html" target="_blank">《用户协议》</a>和<a
              href="./privacyPolicy.html"
              target="_blank"
              >《隐私政策》</a
            >
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div v-show="imgValidatorFlag" class="imgValidatorWrap">
        <div class="mb" @click="hideImgValidator"></div>
        <div class="captchaWrap">
          <div id="captcha"></div>
        </div>
      </div>
    </transition>
    <Footer slot="footer" :concise="true" />
  </Layout>
</template>
<script>
let btnClick = false;
import imgValidator from "./components/jigsaw";
import {
  loginPhoneSendCode,
  pcloginPhoneVerifyCode,
  pcloginPhone
} from "@/api/login.js";
import { Message } from "element-ui";
import { setUserInfo, setToken } from "@/utils/common.js";
import Storage from "good-storage";
export default {
  name: "app",
  data: function() {
    return {
      //当前激活的tab
      activeName: 1,
      tabsList: [
        { id: 1, name: "短信登录" },
        { id: 2, name: "密码登录" }
      ],
      //登录
      mobileForm: {
        phone: "",
        code: "",
        password: ""
      },
      //倒计时
      time: 60,
      //计时器
      timer: null,
      type: "text",
      imgValidatorFlag: false
    };
  },
  methods: {
    tabsChange(id) {
      this.activeName = id;
    },
    //点击忘记密码
    forgetPassword() {
      window.location.href = "./forgetPassword.html?type=1";
    },
    showImgValidator() {
      imgValidator.init({
        el: document.getElementById("captcha"),
        props: {
          phone: this.mobileForm.phone
        },
        onSuccess: () => {
          setTimeout(() => {
            this.hideImgValidator();
          }, 1000);
          this.time = 59;
          this.timer = setInterval(() => {
            if (this.time <= 0) {
              btnClick = false;
              this.time = 60;
              clearInterval(this.timer);
              return;
            }
            this.time--;
          }, 1000);
        },
        onFail: () => {},
        onRefresh: () => {}
      });
      this.imgValidatorFlag = true;
    },
    hideImgValidator() {
      this.imgValidatorFlag = false;
      document.getElementById("captcha").innerHTML = "";
    },
    //获取验证码
    getVerifyCode() {
      if (!btnClick) {
        if (this.mobileForm.phone && /^1\d{10}$/.test(this.mobileForm.phone)) {
          this.showImgValidator();
          // this.getVerifyCodeInit();
        } else {
          Message.error("请输入正确的手机号");
        }
      }
    },
    //验证码初始化
    getVerifyCodeInit() {
      btnClick = true;
      let params = { phone: this.mobileForm.phone };
      loginPhoneSendCode(params).then(res => {
        if (res) {
          this.time = 59;
          this.timer = setInterval(() => {
            if (this.time <= 0) {
              btnClick = false;
              this.time = 60;
              clearInterval(this.timer);
              return;
            }
            this.time--;
          }, 1000);
        }
      });
    },
    //点击登录按钮
    login() {
      let orgInfo = Storage.session.get("ORG_INFO");
      let params = { orgId: orgInfo.id };
      if (this.mobileForm.phone && /^1\d{10}$/.test(this.mobileForm.phone)) {
        params.phone = this.mobileForm.phone;
        //验证码登录
        if (this.activeName === 1) {
          if (this.mobileForm.code) {
            params.verifyCode = this.mobileForm.code;
            this.pcloginPhoneVerifyCodeInit(params);
            // window.sessionStorage.setItem("login","login")
            
          } else {
            Message.error("请输入验证码");
          }
        } else {
          if (this.mobileForm.password) {
            params.password = this.mobileForm.password;
            this.pcloginPhone(params);
            // window.sessionStorage.setItem("login","login")
          } else {
            Message.error("请输入验证码");
          }
        }
      } else {
        Message.error("请输入正确的手机号");
      }
    },
    //验证码登录初始
    pcloginPhoneVerifyCodeInit(params) {
      pcloginPhoneVerifyCode(params).then(res => {
        this.setLoginMessage(res.userLoginInfoVO);
      });
    },
    //手机号登录初始化
    pcloginPhone(params) {
      pcloginPhone(params).then(res => {
        this.setLoginMessage(res.userLoginInfoVO);
      });
    },
    //用户信息以及token存储
    setLoginMessage(res) {
      Message.success("登录成功");
      setUserInfo(res);
      setToken(res.token);
      window.location.href = "./index.html";
    }
  },
  mounted() {},
  beforeDestroy: function() {},
  components: {}
};
</script>
<style lang="scss">
@import "./css/index.scss";
@import "./components/jigsaw.scss";
</style>
